import type { Notice } from './notice.model';

export type NoticeImage = {
  id: string;
  storage_path: string;
  sort_order: number;
};

export function noticeImagesFromNotice(
  notice: Notice | null | undefined,
): NoticeImage[] {
  const edges = notice?.notice_imagesCollection?.edges ?? [];
  return edges
    .map((edge) => edge?.node)
    .filter((node): node is NoticeImage => !!node?.id && !!node.storage_path)
    .slice()
    .sort((a, b) => a.sort_order - b.sort_order);
}

/** RPC 登録直後の行を notice の imagesCollection に足す（既存 id はスキップ）。 */
export function mergeNoticeImageRows(
  notice: Notice,
  rows: NoticeImage[],
): Notice {
  const existing = notice.notice_imagesCollection?.edges ?? [];
  const seen = new Set(
    existing
      .map((edge) => edge?.node?.id)
      .filter((id): id is string => typeof id === 'string' && id.length > 0),
  );
  const extra = rows
    .filter((row) => !seen.has(row.id))
    .map((row) => ({
      node: {
        id: row.id,
        storage_path: row.storage_path,
        sort_order: row.sort_order,
      },
    }));
  return {
    ...notice,
    notice_imagesCollection: {
      ...notice.notice_imagesCollection,
      edges: [...existing, ...extra],
    },
  };
}

/** 画像部品またはスライドカードに実ファイルがあるか。 */
export function noticeHasVisibleContent(
  content: string | null | undefined,
): boolean {
  if (!content) return false;
  const text = content
    .replace(/<br\s*\/?>/gi, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, '')
    .trim();
  return text.length > 0;
}
